<template>
  <v-row class="mb-n4" justify="center" no-gutters>
    <div
      class="box-message-queue checkout-h5"
      style="color: #1976d2 !important; caret-color: #1976d2 !important"
    >
      <v-img
        :src="getHeartEyes"
        height="24"
        width="24"
        max-width="24"
        class="mr-2 mb-1"
      ></v-img>
      <b
        class="mr-1 checkout-h5"
        style="
          color: #1976d2 !important;
          caret-color: #1976d2 !important;
          font-weight: bold;
        "
        >{{ $t("queue.yourTurn") }}</b
      >
      {{ $t("queue.chooseTickets") }}
    </div>
  </v-row>
</template>

<script>
import heartEyes from "../../assets/heart-eyes.png";
export default {
  computed: {
    getHeartEyes() {
      return heartEyes;
    },
  },
};
</script>

<style scoped>
.box-message-queue {
  margin: 20px 0px;
  padding: 0px 15px;
  width: 343px;
  height: 63px;
  background: #1976d244;
  border-radius: 9px;
  display: flex;
  justify-content: start;
  align-items: center;
}
</style>
